import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IptPhase } from '../../model/team/IptPhase';
import { GetTeamRoles } from '../../services/team-role/GetTeamRoles';
import { TeamMemberEntry, TeamRoleUtil } from '../../TeamRoleUtil';
import { GetUsers } from '../../services/user/GetUsers';
import { ReadOnlyState } from '../../../project-details/ReadOnlyStateManager';

@Component({
  selector: 'digires-team-member-list',
  templateUrl: './team-member-list.component.html',
  styleUrls: ['./team-member-list.component.scss']
})
export class TeamMemberListComponent implements OnInit, OnChanges {

  @Output() onAdd = new EventEmitter<TeamMemberEntry>();
  @Output() onRemove = new EventEmitter<TeamMemberEntry>();

  @Input() iptPhase: IptPhase;
  @Input() readOnly: ReadOnlyState;
  @Input() entries: TeamMemberEntry[];
  @Input() allUsers: GetUsers[];
  @Input() allRoles: GetTeamRoles[];
  @Input() showCheckbox: boolean = true;
  @Input() canAdd = true;

  sortedUsers: GetUsers[];
  coreEntries: TeamMemberEntry[];
  widerEntries: TeamMemberEntry[];

  util: TeamRoleUtil;
  nextEntryId: number;
  newMemberEntry: TeamMemberEntry;

  ngOnInit(): void {
    this.newMemberEntry = Object.assign(new TeamMemberEntry(), {
      id: 'newMember',
      user: null,
      fg: new FormGroup({
        user: new FormControl(null, TeamRoleUtil.validateUser),
        role: new FormControl(null),
      }),
      core: false,
      mandatory: false,
      alwaysVisible: true,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.iptPhase) {
      this.util = new TeamRoleUtil(this.iptPhase);
    }
    if (changes.entries) {
      if (this.entries) {
        this.nextEntryId = this.util.getNextEntryId(this.entries);
        this.util.checkForDuplicates(this.entries);
        this.coreEntries = this.util.calculateCoreRoles(this.entries);
        this.widerEntries = this.util.calculateWiderRoles(this.entries);
      } else {
        this.coreEntries = null;
        this.widerEntries = null;
      }
    }
    if (changes.allUsers) {
      if (this.allUsers) {
        this.sortedUsers = this.allUsers
          .slice()
          .filter(u => !!u?.fullName)
          .sort((a, b) => a.fullName.localeCompare(b.fullName));
      } else {
        this.sortedUsers = [];
      }
    }
    if (this.allUsers) {
      this.allUsers = this.allUsers
        .filter(u => !!u?.fullName)
        .sort((a, b) => a.fullName.localeCompare(b.fullName));
    }
  }

  onDelete(entry: TeamMemberEntry) {
    const index = this.entries.indexOf(entry);
    if (index === -1) {
      console.error('onDelete.entry=', entry, 'entries=', this.entries);
      return;
    }
    this.entries.splice(index, 1);
    this.onRemove.emit(entry);

    this.util.checkForDuplicates(this.entries);
    this.coreEntries = this.util.calculateCoreRoles(this.entries);
    this.widerEntries = this.util.calculateWiderRoles(this.entries);
  }

  isAddDisabled(): boolean {
    return !this.canAdd
      || this.readOnly?.isReadOnly()
      || !this.newMemberEntry.getUser()
      || !this.newMemberEntry.fg.value.role;
  }

  onAddEntry() {
    const user = this.newMemberEntry.getUser();
    if (!user) {
      return;
    }
    let role = this.newMemberEntry.getRole();
    if (!role) {
      role = new GetTeamRoles();
      role.name = this.newMemberEntry.fg.value.role;
    }
    const key = '' + this.nextEntryId++;
    const newEntry = this.util.createEntry(key, user, role, false);
    this.entries.push(newEntry);
    this.onAdd.emit(newEntry);

    this.util.checkForDuplicates(this.entries);
    this.coreEntries = this.util.calculateCoreRoles(this.entries);
    this.widerEntries = this.util.calculateWiderRoles(this.entries);

    this.newMemberEntry.fg.patchValue({
      user: new GetUsers(),
      role: null,
    });
  }

}
